// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./sass/_SmartSnippetSuggestions.scss
// module id = 709
// module chunks = 21 88